<template>
    <div class="container-timeviewer">
        <SickDaysModal v-if="sickDaysOptions.isVisible" :show="sickDaysOptions.isVisible" :contractId="sickDaysOptions.contractId" @update="loadContracts" @close="closeSickDaysModal" />
        <div class="filter-container">
            <div class="filter">
                <label for="filter-by">Vertragsstatus</label>
                <select v-model="selectedFilter" id="filter-by">
                    <option value="active">Zur Zeit laufende Verträge</option>
                    <option value="all">Alle Verträge</option>
                    <option value="closed">Geschlossene Verträge</option>
                </select>
            </div>
            <div v-if="getUserData()?.isSecretary" class="filter">
                <label for="filter-user">Mitarbeiter</label>
                <select v-if="getUserData() != null" v-model="userFilter" id="filter-user">
                    <option value="all">Alle Nutzer</option>
                    <option v-for="(user, index) in getUserData().secretaries" :key="index">
                        {{ user }}
                    </option>
                </select>
            </div>
        </div>
        <table class="table">
            <tr>
                <th v-if=showUsers()>Nutzer</th>
                <th>Vertrag Beginn</th>
                <th>Vertrag Ende</th>
                <th>Wochenstunden <span class="sub">h</span></th>
                <th>Soll Zeit <span class="sub">h</span></th>
                <th>Ist Zeit <span class="sub">h</span></th>
                <th>Zeit Differenz <span class="sub">h</span></th>
                <th>Tage Krank</th>
                <th>Urlaubstage</th>
                <th>Aktionen</th>
            </tr>
            <tr v-for="(contract, index) in filteredContracts" :key="index">
                <td v-if=showUsers()>{{ contract.user }}</td>
                <td class="display-right">{{ contract.contractStart }}</td>
                <td :class="{'display-right': contract.contractEnd != 'offen'}">{{ contract.contractEnd }}</td>
                <td class="display-right">{{ contract.weeklyWorkHours }}</td>
                <td class="display-right">{{ contract.targetTime.toFixed(2) }}</td>
                <td class="display-right">{{ contract.actualTime.toFixed(2) }}</td>
                <td class="display-right" :class="{ 'timeRed': contract.timeDifference < 0, 'timeGreen': contract.timeDifference >= 0 }">
                    {{ contract.timeDifference.toFixed(2) }}
                </td>
                <td class="display-right">{{ contract.daysIll }} ({{ hoursIll(contract.daysIll, contract.weeklyWorkHours).toFixed(2) }}h)</td>
                <td class="display-right">{{ contract.holidays }}</td>
                <td><button class="btn-update btn-right" @click="openSickDaysModal(contract.contractId)">Krankheitstage</button></td>
            </tr>
        </table>
    </div>
</template>

<script>
import apiService from '@/service';
import SickDaysModal from './SickDaysModal.vue';

export default {
    name: "TimeViewerComponent",
    components: {
        SickDaysModal
    },
    data() {
        return {
            contractsArray: [],
            selectedFilter: "active",
            listSecretaries: null,
            userFilter: "all",
            sickDaysOptions: {
                isVisible: false,
                selectedContractId: null
            }
        };
    },
    mounted() {
        if (localStorage.getItem("isLoggedIn") != "true") {
            this.$router.push("/");
            return;
        }
        this.loadContracts();
    },
    methods: {
        loadContracts() {
            apiService
                .get(`/ContractWorktime/GetContracts?users=${this.getUserData().secretariesUids}`)
                .then((response) => {
                    this.contractsArray = response.data.map((item) => ({
                        user: item.user,
                        contractStart: new Intl.DateTimeFormat("de-DE", { month: '2-digit', day: '2-digit', year: 'numeric' }).format(new Date(item.contractStart)),
                        contractEnd: item.contractEnd != null ? new Intl.DateTimeFormat("de-DE", { month: '2-digit', day: '2-digit', year: 'numeric' }).format(new Date(item.contractEnd)) : "offen",
                        weeklyWorkHours: item.weeklyWorkHours,
                        targetTime: item.targetTime,
                        actualTime: item.actualTime,
                        timeDifference: item.timeDifference,
                        daysIll: item.daysIll,
                        holidays: item.holidays,
                        contractId: item.contractId,
                        isClosed: item.isClosed,
                    }));
                })
                .catch((error) => {
                    console.log("OutputTimes error:", error);
                })
                .finally(() => {
                    console.log("OutputTimes finally:");
                });
        },
        filterContracts() {
            let filteredContracts
            if (this.selectedFilter === "active") {
                filteredContracts = this.contractsArray.filter((contract) => contract.contractEnd === "offen" || new Date(contract.contractEnd.split(".").reverse().join(".")) >= new Date());
            } else if (this.selectedFilter === "all") {
                filteredContracts = this.contractsArray;
            } else if (this.selectedFilter === "closed") {
                filteredContracts = this.contractsArray.filter((contract) =>  new Date(contract.contractEnd.split(".").reverse().join(".")) <= new Date());
            }
            if (this.userFilter !== "all") {
                filteredContracts = filteredContracts.filter((contract) => {
                    if (this.getUserData() != null) {
                        this.listSecretaries = this.getUserData().secretaries;
                        const secretaryIndex = this.listSecretaries.indexOf(this.userFilter);
                        return contract.user === this.getUserData().secretariesUids[secretaryIndex];
                    }
                    return contract.user === null;
                });
            }
            return filteredContracts;
        },
        hoursIll(daysIll, weeklyWorkHours) {
            return daysIll * (weeklyWorkHours / 5)
        },
        getUserData() {
            var jsonString = localStorage.getItem('userData');
            return jsonString ? JSON.parse(jsonString) : null;
        },
        showUsers() {
            if (this.userFilter === "all") {
                return true;
            }
            return false;
        },
        openSickDaysModal(id){
            this.sickDaysOptions.contractId = id;
            this.sickDaysOptions.isVisible = true;
        },
        closeSickDaysModal(){
            this.sickDaysOptions.contractId = null;
            this.sickDaysOptions.isVisible = false;
        }
    },
    computed: {
        filteredContracts() {
            return this.filterContracts();
        },
    },
};
</script>
<style>
.container-timeviewer {
    display: flex;
    flex-direction: column;
    gap: 1rem
}


</style>